import React from "react";
import InputForm from "../../generales/InputForm";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import Action from "../../Action";
import { useState ,useEffect} from 'react';
import Modal from "react-modal";
import ModalLinKHost from "../ModalLinKHost";
// import "./InfoFolio.css";
import LoadSimple from "../../LoadSimple";
import {useFetch }from "../../../hooks/useFetch";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const InfoFolio = ({server,hostSelected,editActive,dataCis,cisData,languaje,closHostsModal,Registrar,loading}) => {
    const folio_data=useFetch('cassia/cis_v2/folios/'+cisData['f.folio_id']+'/details','','','GET',server)
    // const labels = {
    //   ip: "IP",
    //   hostid: "Host ID",
    //   ci_group_id: "Grupo CI",
    //   name: "Nombre",
    //   affiliation: "Afiliación",
    //   description: "Descripción",
    //   location_id: "Ubicación",
    //   service_id: "Servicio",
    //   brand_id: "Marca",
    //   model_id: "Modelo",
    //   version: "Versión",
    //   serial_no: "Número de serie",
    //   mac: "MAC",
    //   request_user: "Usuario solicitante",
    //   auth_user: "Usuario autorizado",
    //   user_comment: "Comentario",
    // };

    const labels = {
    //     folio_id: "ID de folio",
    //     name: "Nombre",
    //      hostid: "Host ID",
    //   affiliation: "Afiliación",
      request_user: "Solicitante",
      auth_user: "Autorizador",
      created_at: "Fecha de creación",
        updated_at: "Fecha de actualización",
    //      type: "Tipo",
    //   ci_group_name: "Nombre del grupo CI",
    //   location: "Ubicación",
    //   service: "Servicio",
    //   brand: "Marca",
    //   model: "Modelo",
    //   description: "Descripción",
    //   detail: "Detalle",
    //   ip: "IP",
    //   mac: "MAC",
    //   serial_no: "Número de serie",
      user_comment: "Comentario del usuario",
    //   version: "Versión"
    };
    const statusWF={
      'PENDING':'rgba(255, 255, 151, 0.589)',
      'IN_PROCESS':'rgba(183, 255, 134, 0.59)',
      'FINALIZED':'rgba(183, 255, 134, 0.59)',
      'REJECTED':'rgba(255, 166, 156, 0.59)',
      'CANCELLED':'rgba(255, 166, 156, 0.59)',
      'PENDING_AUTHORIZATION':'rgba(255, 255, 151, 0.589)',
    }
    const boderWF={
      'PENDING':'rgb(214, 214, 27)',
      'IN_PROCESS':'rgb(15, 191, 0)',
      'FINALIZED':'rgb(15, 191, 0)',
      'REJECTED':'rgba(191, 18, 0, 0.59)',
      'CANCELLED':'rgba(191, 18, 0, 0.59)',
      'PENDING_AUTHORIZATION':'rgb(214, 214, 27)',
    }
    const statustext={
     'IN_PROCESS':'#fff',
      'PENDING':'var(--text-color)',
      'FINALIZED':'var(--green)',
       'REJECTED':'#fff',
        'CANCELLED':'var(--red-alert)',
        'PENDING_AUTHORIZATION':'var(--text-color)',
    }
    const txtWF={
      'IN_PROCESS':'En Proceso',
      'PENDING':'Pendiente',
      'FINALIZED':'Finalizado',
       'REJECTED':'Rechazado',
        'CANCELLED':'Cancelado',
        'PENDING_AUTHORIZATION':'Pendiente de Autorización',
    }
    const imgWF={
      'IN_PROCESS':'peticion',
      'PENDING':'pendiente',
      'FINALIZED':'aceptar',
       'REJECTED':'rechazar',
        'CANCELLED':'cancel',
        'PENDING_AUTHORIZATION':'warning',
    }
    // const cambios = Object.keys(cisData).reduce((acc, key) => {
    //   const nuevo = cisData[key];
    //   const actual = dataCis[key];

    //   // Si son iguales, no lo agregamos
    //   if (nuevo === actual) return acc;

    //   acc.push({
    //     field: key,
    //     old: actual,
    //     new: nuevo
    //   });

    //   return acc;
    // }, []);

    const parseChanges2 = (text) => {
      const lines = text.split("\n").filter(l => l.includes("->"));

      const mappings = {
        "Descripcion": "description",
        "IP": "ip",
        "Afiliacion": "affiliation",
        "Serial No.": "serial_no",
        "MAC": "mac",
        "Marca": "brand",
        "Modelo": "model",
        "Ubicacion": "location",
        "Servicio": "service",
        "Grupo de CI": "ci_group_name"
      };

      return lines.map(line => {
        const [label, values] = line.split(":");
        const [oldVal, newVal] = values.split("->").map(v => v.trim());

        const field = mappings[label.trim()] || label.trim().toLowerCase();

        return {
          field,
          old: oldVal === "Ninguno" ? "" : oldVal,
          new: newVal
        };
      });
    };

    const parseChanges = (text) => {
      return text
        .split('\n')
        .map(line => line.trim())
        .filter(line => line && line.includes('->'))
        .map(line => {
          // separa por el primer ":" para obtener la "etiqueta"
          const colonIndex = line.indexOf(':');
          const rawLabel = colonIndex !== -1 ? line.slice(0, colonIndex).trim() : '';
          const rest = colonIndex !== -1 ? line.slice(colonIndex + 1).trim() : line;

          // separa OLD -> NEW por la flecha (la primera aparición)
          const arrowIndex = rest.indexOf('->');
          let oldRaw = '', newRaw = '';
          if (arrowIndex !== -1) {
            oldRaw = rest.slice(0, arrowIndex).trim();
            newRaw = rest.slice(arrowIndex + 2).trim();
          } else {
            // si por alguna razón no hay flecha, todo va a new
            newRaw = rest.trim();
          }

          // Normalizaciones
          const oldVal = (oldRaw === 'Ninguno' || oldRaw === 'None') ? '' : oldRaw;
          const newVal = newRaw;

          // campo normalizado para usar como key (opcional)
          const field = rawLabel
            .toLowerCase()
            .replace(/\./g, '')          // quitar puntos
            .replace(/\s+/g, '_')       // espacios -> guion bajo
            .replace(/[^a-z0-9_áéíóúñ()-]/gi, '') // quitar caracteres raros (pero dejar acentos y paréntesis)
            .trim();

          return {
            label: rawLabel, // texto tal cual viene en la línea (para mostrar si quieres)
            field,            // clave normalizada (para buscar en labels si existe)
            old: oldVal,
            new: newVal
          };
        });
    };
    return(
        <>
            <div className="confirm-action-container">
                <div className="compact-confirm-action">
                    <div className="confirm-action-titulo">
                        {'Información del Folio #'+cisData['f.folio_id']} 
                    </div>
                    <div className="confirm-action-body">
                        {(folio_data.loading)?<LoadSimple></LoadSimple>: <>
                        <div className="cont-msg-alert-confirm-action" style={{marginBottom:'10px'}}>
                            {(folio_data.loading)?'':<div className="compact-msg-alert-confirm-action" style={{border:`2px solid ${boderWF[folio_data.data.data[0]?.status]}`,backgroundColor:statusWF[folio_data.data.data[0]?.status]}}>
                                <img  className='icon-msg-alert' src={"/iconos/"+imgWF[folio_data.data.data[0]?.status]+".png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                <div className="msg-alert-txt-confirm-action">

                                    {'Este folio se encuentra en estatus "'+txtWF[folio_data.data.data[0]?.status]+'"'}
                                </div>
                            </div>}
                            
                        </div>
                        <div className="cont-msg-alert-confirm-action">
                            {(folio_data.loading)?'':<div className="compact-msg-alert-confirm-action" style={{height:'auto',border:`2px solid var(--txt-color)`,backgroundColor:'var(--hover-color)'}}>
                               
                                <div className="msg-alert-txt-confirm-action"  style={{display: 'grid',gridTemplateColumns: 'repeat(2, 1fr)'}}>
                                    {Object.keys(labels)                     // orden original de labels
                                    .filter(key => folio_data.data.data[0][key] !== null && folio_data.data.data[0][key] !== "") // solo con info
                                    .map(key => (
                                        <p key={key}>
                                        <strong style={{ color: 'var(--third-color)' }}>
                                            {labels[key] + ': '}
                                        </strong>
                                        {folio_data.data.data[0][key]}
                                        </p>
                                    ))}
                                    
                                </div>
                            </div>}
                            
                        </div>
                        
                        <div className="cont-datos-confirm-action">
                            <div className="compact-datos-confirm-action" >
                               
                                <>
                                {/* {Object.entries(folio_data.data.data[0])
                                    .filter(([key, value]) => value !== null && value !== "") // solo valores con info
                                    .map(([key, value]) => (
                                        <p key={key}>
                                        <strong style={{ color: 'var(--third-color)' }}>
                                            {labels[key] + ': '}
                                        </strong>
                                        {value}
                                        </p>
                                    ))} */}
                                    {parseChanges(folio_data.data.data[0]?.detail).map((item) => (
  <div className="row-change-confirm-action" key={item.field}>
    <div className="label-confirm-action-title" style={{width:'25%'}}>
      <strong>{item.label + ': '}</strong>
    </div>

    <div className="change-values-confirm-action" style={{width:'75%'}}>
      {
    //   (item.field === 'user_comment' ||
    //     item.field === 'auth_user' ||
    //     item.field === 'request_user')
    //     ? ''
    //     :
         (
          <>
            <div
              className="old-value-confirm-action"
              title={item.old ? item.old : "Vacio"}
            >
              {item.old ? item.old : "Vacio"}
            </div>

            <div className="arrow-change-confirm-action">→</div>
          </>
        )
      }

      <div className="new-value-confirm-action" title={item.new}>
        {item.new}
      </div>
    </div>
  </div>
))}
                                    
                                </>
                                
                                {/* {(editActive)?cambios.map(item => (
                                        
                                        <div className="row-change-confirm-action" key={item.field}>
                                            <div className="label-confirm-action-title"><strong>{labels[item.field] + ': '}</strong></div>
                                            <div className="change-values-confirm-action">
                                               {(item.field=='user_comment' || item.field=='auth_user' || item.field=='request_user')?'':<> <div className="old-value-confirm-action" title={(item.old==undefined || item.old==null || item.old=="")?"Vacio":item.old}>
                                                    {(item.old==undefined || item.old==null || item.old=="")?"Vacio":item.old}
                                                </div>
                                                <div className="arrow-change-confirm-action">→</div></>}
                                                <div className="new-value-confirm-action" title={item.new}>
                                                    {item.new}
                                                </div>
                                            </div>
                                            
                                        </div>
                                    )):Object.entries(cisData)
                                    .filter(([key, value]) => value !== null && value !== "") // solo valores con info
                                    .map(([key, value]) => (
                                        <p key={key}>
                                        <strong style={{ color: 'var(--third-color)' }}>
                                            {labels[key] + ': '}
                                        </strong>
                                        {value}
                                        </p>
                                    ))
                                    }  */}
                                   
                                {/* <p><strong style={{color:'var(--third-color)'}}>{'Alias: '}</strong> {cisData.affiliation}</p>
                                <p><strong>{'Nombre: '}</strong> {cisData.name}</p>
                                <p><strong>{'Descripción: '}</strong> {cisData.description}</p>      */}
                            </div>
                        </div>
                        </>}
                    </div>
                    <div className="confirm-action-footer">
                        <div className="cont-buttons-panel" style={{width:'60%', display:'flex',right:'unset',top:'unset'} }>
                                         {
                                          
                                          (loading)?<LoadSimple></LoadSimple>:
                                           
                                          <>
                                          <Action
                                          disabled={false}
                                          origen="Azul"
                                          titulo={capitalizeFirstLetter(lang[languaje]['aceptar'])}
                                          action={()=>{closHostsModal()}}
                                        />
                                        
                                          </>
                                          
                                         }
                                            
                                          
                                            {/* <Action
                                        disabled={false}
                                        origen="Cancelar"
                                        titulo={""+capitalizeFirstLetter(lang[languaje]['cancelar'])}
                                        action={()=>{ closHostsModal() }}
                                      /> */}
                                        </div>
                    </div>
                </div>
            </div>    
        </>
    )
}

export default InfoFolio;
 